import React from "react";
import { useState, useContext } from "react";
import { useHistory, Link } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import logo from "../img/Logo_eslogan-01.png";
import LoginFondo from "../img/Fondo.png"; // Import using relative path
import {
  Avatar,
  Button,
  CssBaseline,
  TextField,
  Box,
  Grid,
  Typography,
} from "@material-ui/core";
import Linkx from "@material-ui/core/Link";
import LockOutlinedIcon from "@material-ui/icons/LockOutlined";

import { APIContext } from "../context";

function Copyright() {
  return (
    <Typography variant="body2" color="textSecondary" align="center">
      {"Copyright © "}
      <Linkx component={Link} color="inherit" to="/">
        Capital Factoring
      </Linkx>{" "}
      {new Date().getFullYear()}
      {"."}
    </Typography>
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    height: "100vh",
    backgroundImage: `url(${LoginFondo})`,
    backgroundRepeat: "no-repeat",
    backgroundColor:
      theme.palette.type === "light"
        ? theme.palette.grey[50]
        : theme.palette.grey[900],
    backgroundSize: "cover",
    backgroundPosition: "top",
  },
  container: {
    alignItems: "center",
    display: "flex",
    justifyContent: "center",
  },
  image: {},
  paper: {
    margin: theme.spacing(8, 4),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    backgroundColor: "white",
    padding: "30px",
    borderRadius: "10px",
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
  },
  AppLogo: {
    //backgroundColor: '#fff',
    height: "130px",
    padding: "10px",
    display: "flex",
    width: "210px",
    //alignItems: "center",
    justifyContent: "center",
  },
  AppLogoMenuOpen: {
    overflow: "auto",
    objectFit: "contain",
  },

  //});
}));

export default function Sign_In(props) {
  const {
    signIn,
    sendPasswordEmail,
    dialogAlertContent,
    setDialogAlertContent,
    setDialogAlertOpen,
  } = useContext(APIContext);

  const classes = useStyles();
  const [autenticacion, setAutenticacion] = useState({
    username: "",
    password: "",
  });
  const [email, setEmail] = useState({
    username: "",
  });

  const [viewForget, setViewForget] = useState(false);

  const history = useHistory();

  function verificar_inputs() {
    let error = false;

    if (autenticacion.username === "" || autenticacion.password === "") {
      error = true;
    }

    if (error) {
      setDialogAlertOpen(true);
      setDialogAlertContent({
        ...dialogAlertContent,
        mensaje: "Ingrese el Usuario y Contraseña para continuar",
        titulo: "Error al ingresar",
      });
      return false;
    } else {
      return true;
    }
  }

  function verificar_email() {
    let error = false;

    if (email === "") {
      error = true;
    }

    if (error) {
      setDialogAlertOpen(true);
      setDialogAlertContent({
        ...dialogAlertContent,
        mensaje: "Ingrese el correo electrónico para recibir su contraseña",
        titulo: "Recuperar Contraseñas",
      });
      return false;
    } else {
      return true;
    }
  }

  const updateField = (e) => {
    setAutenticacion({
      ...autenticacion,
      [e.target.name]: e.target.value,
    });
  };

  const updateEmailField = (e) => {
    setEmail({
      ...email,
      username: e.target.value,
    });
  };

  async function SignIn(e) {
    e.preventDefault();
    if (verificar_inputs()) {
      const res = await signIn(autenticacion);
      console.log("res ", res);
      if (res) {
        history.push("/admin");
      } else {
        return;
      }
    }
  }

  async function SendPass(e) {
    e.preventDefault();
    if (verificar_email()) {
      await sendPasswordEmail(email);
    }
  }

  return (
    <Grid container component="main" className={classes.root}>
      <CssBaseline />
      <Grid item xs={false} sm={2} md={4} className={classes.image} />
      <Grid
        item
        xs={12}
        sm={8}
        md={4}
        elevation={6}
        square
        className={classes.container}
      >
        <div className={classes.paper} elevation={6}>
          {!viewForget ? (
            <>
              <div className={classes.AppLogo}>
                <img
                  src={logo}
                  className={classes.AppLogoMenuOpen}
                  alt="Capital Factoring"
                />
              </div>

              <Typography component="h1" variant="h5">
                Bienvenido
              </Typography>
              <form className={classes.form} onSubmit={SignIn} noValidate>
                <div>
                  <TextField
                    variant="outlined"
                    margin="normal"
                    required
                    fullWidth
                    onChange={updateField}
                    name="username"
                    label="Correo Electrónico"
                    id="email"
                    autoComplete="email"
                    autoFocus
                  />
                  <TextField
                    variant="outlined"
                    margin="normal"
                    required
                    fullWidth
                    onChange={updateField}
                    name="password"
                    label="Contraseña"
                    type="password"
                    id="password"
                    autoComplete="current-password"
                  />
                </div>
                {/* <FormControlLabel
              control={<Checkbox value="remember" color="primary" />}
              label="Remember me"
            /> */}

                <Button
                  type="submit"
                  fullWidth
                  variant="contained"
                  color="primary"
                  className={classes.submit}
                >
                  Iniciar Sesión
                </Button>

                <Grid container></Grid>
                <Box mt={5}>
                  <Copyright />
                </Box>
              </form>
            </>
          ) : (
            <>
              <Avatar className={classes.avatar}>
                <LockOutlinedIcon />
              </Avatar>

              <Typography component="h1" variant="h5">
                Recuperar Contraseña
              </Typography>
              <form className={classes.form} onSubmit={SendPass} noValidate>
                <TextField
                  value={email.username}
                  variant="outlined"
                  margin="normal"
                  required
                  fullWidth
                  onChange={updateEmailField}
                  name="emailrestablecer"
                  label="Correo Electrónico"
                  id="emailrestablecer"
                  autoFocus
                />
                <Button
                  type="submit"
                  fullWidth
                  variant="contained"
                  color="primary"
                  className={classes.submit}
                >
                  Solicitar
                </Button>

                <Grid container>
                  {
                    <Grid item xs>
                      <Linkx
                        variant="body2"
                        onClick={(event) => setViewForget(false)}
                      >
                        Volver al inicio de sesión
                      </Linkx>
                    </Grid>
                  }
                </Grid>
                <Box mt={5}>
                  <Copyright />
                </Box>
              </form>
            </>
          )}
        </div>
      </Grid>
      <Grid item xs={false} sm={2} md={4} className={classes.image} />
    </Grid>
  );
}
